module.exports = __webpack_public_path__ + "static/media/4.f0aa2dd9.png";